import React, { useState } from "react";
import { Button, Form, Input, message, Select, Upload } from "antd";
import axios from "axios";
import { SERVER_ADDRESS } from "../../../Config/Config";
import { PlusOutlined } from "@ant-design/icons";
const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 6,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 14,
    },
  },
};

const AddStyle = () => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [imageBase64, setImageBase64] = useState(null);

  // Convert file to base64
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handleImageChange = async ({ fileList: newFileList }) => {
    setFileList(newFileList);
    if (newFileList.length > 0 && newFileList[0].originFileObj) {
      const base64 = await getBase64(newFileList[0].originFileObj);
      setImageBase64(base64);
    } else {
      setImageBase64(null);
    }
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  const onFinish = async (values) => {
    try {
      const payload = {
        ...values,
        style_image: imageBase64, // send base64 string
      };
      const response = await axios.post(
        `${SERVER_ADDRESS}/api/add-style`,
        payload
      );
      if (response.status === 200) {
        message.success({ content: "Style added successfully", duration: 2 });
        form.resetFields();
      } else {
        message.error({ content: "Cannot add style", duration: 2 });
      }
    } catch (error) {
      message.error({ content: "Internal server error", duration: 2 });
    }
  };

  return (
    <div
      style={{
        marginTop: "5rem",
      }}
    >
      <div
        style={{
          fontSize: "2rem",
        }}
      >
        Fill Details
      </div>
      <Form
        {...formItemLayout}
        form={form}
        style={{
          backgroundColor: "white",
          width: "60rem",
          marginTop: "2rem",
          padding: "2rem",
          justifySelf: "center",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          borderRadius: "0.6rem",
        }}
        labelCol={{ span: 3 }}
        wrapperCol={{ span: 14, offset: 1 }}
        onFinish={onFinish}
      >
        <Form.Item
          label="Style Name"
          name="style_name"
          rules={[
            { required: true, message: "Enter the style name" },
            {
              validator: (_, value) => {
                if (value && value.trim().toLowerCase() === "image") {
                  return Promise.reject("Style name cannot be 'image'");
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input placeholder="Enter style name"></Input>
        </Form.Item>
        <Form.Item
          label="Search Key"
          name="style_search_key"
          rules={[
            { required: true, message: "Enter the style search key name" },
          ]}
        >
          <Input placeholder="Enter search key"></Input>
        </Form.Item>
        <Form.Item
          label="Customize"
          name="is_customize"
          rules={[{ required: true, message: "Select the Customize Option" }]}
        >
          <Select placeholder="Select Customize">
            <Option value={1} key={1}>
              Yes
            </Option>
            <Option value={2} key={2}>
              No
            </Option>
          </Select>
        </Form.Item>
        <Form.Item
          label="Style Cover Image"
          name="style_image"
          valuePropName="fileList"
          getValueFromEvent={(e) => e && e.fileList}
          rules={[
            {
              validator: async () => {
                if (!imageBase64) {
                  return Promise.reject("Kindly Upload style Image");
                }
              },
            },
          ]}
        >
          <Upload
            listType="picture-card"
            fileList={fileList}
            onChange={handleImageChange}
            onPreview={onPreview}
            showUploadList={{ showPreviewIcon: false }}
            beforeUpload={() => false} // prevent auto-upload
          >
            {fileList.length >= 1 ? null : (
              <div>
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>Upload</div>
              </div>
            )}
          </Upload>
        </Form.Item>
        <Form.Item
          wrapperCol={{
            offset: 10,
            span: 16,
          }}
        >
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default AddStyle;
